import * as React from 'react';
import { FormGroup } from '../../form/FormGroup';
import { FormInput } from '../../form/FormInput';
import { FormComponentProps } from '../../form/Form';
import { FormTransferContainer } from '../../form/FormTransferContainer';

const HAND_FOR_HAND_CONFIGURATION_MODEL = 'handForHandConfiguration';

interface HandForHandConfigurationPanelProps extends FormComponentProps {
}

export class HandForHandConfigurationPanel extends React.Component<HandForHandConfigurationPanelProps, {}> {
    getModel() {
        return this.props.fieldSet.getModelValue(HAND_FOR_HAND_CONFIGURATION_MODEL);
    }

    render() {
        const isEnabled: boolean = this.getModel().enabled;

        return (
            <FormTransferContainer {...this.props} model={HAND_FOR_HAND_CONFIGURATION_MODEL}>
                <div className='row target-tournament-panel'>
                    <div className='col-lg-12'>
                        <div className='ibox float-e-margins'>
                            <div className='ibox-title'>
                                <h5>Hand For Hand Configuration</h5>
                            </div>
                            <div className='ibox-content'>
                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Is Hand for Hand enabled</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='checkbox' model='enabled'/>
                                    </div>
                                </FormGroup>
                                {isEnabled && <div>
                                    <div className='hr-line-dashed'/>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Table size based limits</label>
                                        <div className='col-sm-10'>
                                            <FormInput type='text' model='tableSizeBasedLimits'/>
                                        </div>
                                        <span
                                            className='help-block m-b-none'>{this.previewTableSizeBasedLimits()}</span>
                                    </FormGroup>
                                    <div className='hr-line-dashed'/>
                                    <FormGroup className='form-group'>
                                        <label className='col-sm-2 control-label'>Bubble based limits</label>
                                        <div className='col-sm-10'>
                                            <FormInput type='text' model='bubbleBasedLimit'/>
                                        </div>
                                        <span className='help-block m-b-none'>{this.previewBubbleBasedLimit()}</span>
                                    </FormGroup>
                                    <div className='hr-line-dashed'/>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </FormTransferContainer>
        );
    }

    private previewTableSizeBasedLimits() {
        const tableSize = this.props.fieldSet.getModelValue('configuration').seatsPerTable;
        const tableSizeBasedLimitsValue: number[] | string = this.getModel().tableSizeBasedLimits;

        let tableSizeBasedLimits = [];

        if(typeof tableSizeBasedLimitsValue === 'string') {
            tableSizeBasedLimits = tableSizeBasedLimitsValue.split(',');
        }
        else {
            tableSizeBasedLimits = tableSizeBasedLimitsValue;
        }


        return tableSizeBasedLimits === null ? 'n/a' : tableSizeBasedLimits.map((limit, index) => {
            return '' + tableSize * (index + 1) + '-' + limit;
        }).join(',');
    }

    private previewBubbleBasedLimit() {
        const bubbleBasedLimit: number = this.getModel().bubbleBasedLimit;

        return bubbleBasedLimit === null ? 'n/a' : 'B-' + bubbleBasedLimit;
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/HandForHandConfigurationPanel.tsx